/**
 * React bindings shared by the easing picker, the Bezier editor and the templates dialog (W2-05).
 *
 * Dialogs are hosted at the app level, so they read the open project through `services.store` (following project
 * swaps) and re-render on document changes, settings changes and editor-store changes they depend on.
 *
 * The store, settings and editor bindings come from the shared module src/app/registry/react.ts (CR-W2-05-4).
 */

import { useMemo } from 'react';
import type { MessageRef } from '../../core/util/types';
import { i18n } from '../../i18n/runtime';
import type { MessageKey } from '../../i18n/types';
import { useT } from '../../i18n/useT';
export {
  useServicesStore,
  useDocVersion,
  useSettings,
  useEditorValue as useEditorSlice,
} from '../../app/registry/react';

export interface Text {
  readonly t: (key: MessageKey | string, params?: Readonly<Record<string, string | number>>) => string;
  readonly tr: (ref: MessageRef) => string;
}

/** Translation functions of the app runtime (re-render on locale change). */
export function useText(): Text {
  const t = useT();
  return useMemo(() => ({ t, tr: (ref: MessageRef) => i18n.tr(ref) }), [t]);
}
